var map = {
	"./AppClipSign.JPG": 912,
	"./DrivuQScreenshot": 513,
	"./DrivuQScreenshot.png": 513,
	"./ShopViewTemplate": 514,
	"./ShopViewTemplate.png": 514,
	"./Tap": 515,
	"./Tap.png": 515,
	"./Track": 516,
	"./Track.png": 516,
	"./accepted_order_icon.webp": 509,
	"./add-background": 517,
	"./add-background.png": 517,
	"./add-logo": 518,
	"./add-logo.png": 518,
	"./adv_bg": 519,
	"./adv_bg.png": 519,
	"./android2": 520,
	"./android2.png": 520,
	"./android_platform": 521,
	"./android_platform.png": 521,
	"./angle_doubleup": 522,
	"./angle_doubleup.svg": 522,
	"./app-discover-screen": 523,
	"./app-discover-screen.png": 523,
	"./app-green-circle": 524,
	"./app-green-circle.png": 524,
	"./app-reorder-screen": 525,
	"./app-reorder-screen.png": 525,
	"./app-store": 526,
	"./app-store-icon": 527,
	"./app-store-icon.png": 527,
	"./app-store.png": 526,
	"./app_coin": 528,
	"./app_coin.png": 528,
	"./app_store_resized": 529,
	"./app_store_resized.png": 529,
	"./apple-icon": 530,
	"./apple-icon.png": 530,
	"./apple-pay-LogoSvg": 253,
	"./apple-pay-LogoSvg.png": 253,
	"./applepay": 531,
	"./applepay.png": 531,
	"./appstore-icon": 532,
	"./appstore-icon.png": 532,
	"./arrive": 533,
	"./arrive.jpg": 533,
	"./available_on_the_app_store": 534,
	"./available_on_the_app_store.png": 534,
	"./background_influencer": 535,
	"./background_influencer.jpg": 535,
	"./basics": 536,
	"./basics.svg": 536,
	"./battery-orange": 537,
	"./battery-orange.png": 537,
	"./bg": 538,
	"./bg.png": 538,
	"./billing-icon": 539,
	"./billing-icon.png": 539,
	"./black-drivu-logo": 540,
	"./black-drivu-logo.png": 540,
	"./blue-trash": 541,
	"./blue-trash.svg": 541,
	"./branch-location": 542,
	"./branch-location.png": 542,
	"./call_icon.webp": 913,
	"./car_arrive": 543,
	"./car_arrive.png": 543,
	"./car_icon": 544,
	"./car_icon.png": 544,
	"./car_left": 545,
	"./car_left.png": 545,
	"./cash-pay": 546,
	"./cash-pay.png": 546,
	"./caution": 547,
	"./caution.png": 547,
	"./cc": 548,
	"./cc.png": 548,
	"./choose": 549,
	"./choose.png": 549,
	"./correct-sign": 550,
	"./correct-sign.png": 550,
	"./credit-card-empty": 243,
	"./credit-card-empty.png": 243,
	"./credit-card-icon": 551,
	"./credit-card-icon.png": 551,
	"./credit-card-payment-logo2": 552,
	"./credit-card-payment-logo2.png": 552,
	"./credit_card": 553,
	"./credit_card.png": 553,
	"./cropper_images/bg": 554,
	"./cropper_images/bg.png": 554,
	"./customer-location": 555,
	"./customer-location.png": 555,
	"./desktop-newsletter": 556,
	"./desktop-newsletter.png": 556,
	"./device-status-icon": 557,
	"./device-status-icon.png": 557,
	"./done-icon": 558,
	"./done-icon.png": 558,
	"./door-sticker2": 559,
	"./door-sticker2.jpeg": 559,
	"./doorsticker": 560,
	"./doorsticker.jpeg": 560,
	"./doorsticker1": 561,
	"./doorsticker1.jpeg": 561,
	"./doorsticker3": 562,
	"./doorsticker3.jpg": 562,
	"./down_arrow": 563,
	"./down_arrow.gif": 563,
	"./drivu-black-logo2": 564,
	"./drivu-black-logo2.png": 564,
	"./drivu_logo_H": 565,
	"./drivu_logo_H.png": 565,
	"./drivu_white_logo": 566,
	"./drivu_white_logo.png": 566,
	"./drivu_white_logo2": 567,
	"./drivu_white_logo2.png": 567,
	"./drivuhomescreenimage": 568,
	"./drivuhomescreenimage.jpg": 568,
	"./email_logo": 569,
	"./email_logo.png": 569,
	"./empty-gift": 570,
	"./empty-gift.png": 570,
	"./empty-image": 571,
	"./empty-image.jpg": 571,
	"./feedback": 572,
	"./feedback.png": 572,
	"./free-brand": 573,
	"./free-brand.png": 573,
	"./free-icon": 574,
	"./free-icon.png": 574,
	"./free-stamp": 575,
	"./free-stamp.png": 575,
	"./gift": 576,
	"./gift-icon": 577,
	"./gift-icon.png": 577,
	"./gift.png": 576,
	"./google-play": 578,
	"./google-play-icon": 579,
	"./google-play-icon.png": 579,
	"./google-play.png": 578,
	"./google_play_store_resized": 580,
	"./google_play_store_resized.png": 580,
	"./green_timer": 581,
	"./green_timer.png": 581,
	"./group-3@2x": 582,
	"./group-3@2x.png": 582,
	"./growth-color-icon": 583,
	"./growth-color-icon.png": 583,
	"./growth-icon": 584,
	"./growth-icon.png": 584,
	"./home-icon": 585,
	"./home-icon.png": 585,
	"./home-screen-backgroud2": 586,
	"./home-screen-backgroud2.png": 586,
	"./iPhonex": 587,
	"./iPhonex.png": 587,
	"./instagram": 588,
	"./instagram-white-icon2": 589,
	"./instagram-white-icon2.png": 589,
	"./instagram.png": 588,
	"./ios2": 590,
	"./ios2.png": 590,
	"./ios_platform": 591,
	"./ios_platform.png": 591,
	"./ipad": 592,
	"./ipad.png": 592,
	"./ipadimage": 593,
	"./ipadimage.png": 593,
	"./iphone-screen": 594,
	"./iphone-screen.jpg": 594,
	"./iphonex_splash": 595,
	"./iphonex_splash.png": 595,
	"./lane/Tablet": 596,
	"./lane/Tablet.svg": 596,
	"./lane/black-icon_instagram": 597,
	"./lane/black-icon_instagram.svg": 597,
	"./lane/blacn-icon-twitter": 598,
	"./lane/blacn-icon-twitter.svg": 598,
	"./lane/collapse-close": 599,
	"./lane/collapse-close.png": 599,
	"./lane/collapse-open": 600,
	"./lane/collapse-open.png": 600,
	"./lane/dashboard": 601,
	"./lane/dashboard.png": 601,
	"./lane/done_icon": 602,
	"./lane/done_icon.png": 602,
	"./lane/header-sign": 603,
	"./lane/header-sign.svg": 603,
	"./lane/header-tablet": 604,
	"./lane/header-tablet.svg": 604,
	"./lane/icon_calendar": 605,
	"./lane/icon_calendar.svg": 605,
	"./lane/icon_increae": 606,
	"./lane/icon_increae.svg": 606,
	"./lane/icon_map": 607,
	"./lane/icon_map.svg": 607,
	"./lane/icon_menu": 608,
	"./lane/icon_menu.svg": 608,
	"./lane/icon_send": 609,
	"./lane/icon_send.svg": 609,
	"./lane/icon_star": 610,
	"./lane/icon_star.svg": 610,
	"./lane/laptop": 611,
	"./lane/laptop.svg": 611,
	"./lane/map_mobile": 612,
	"./lane/map_mobile.svg": 612,
	"./lane/qr-sign-half": 613,
	"./lane/qr-sign-half.svg": 613,
	"./lane/qr_code": 614,
	"./lane/qr_code.png": 614,
	"./lane/shape": 615,
	"./lane/shape.svg": 615,
	"./lane/sign": 616,
	"./lane/sign.png": 616,
	"./lane/sign0.5": 617,
	"./lane/sign0.5.png": 617,
	"./lane/street-background": 618,
	"./lane/street-background.svg": 618,
	"./lane/tablet_shadow": 619,
	"./lane/tablet_shadow.png": 619,
	"./lane/take-coffee": 620,
	"./lane/take-coffee.svg": 620,
	"./lane/waiter-app-half": 621,
	"./lane/waiter-app-half.svg": 621,
	"./lane/waiter-apps": 622,
	"./lane/waiter-apps.svg": 622,
	"./left": 623,
	"./left.jpg": 623,
	"./loading-wheel-gif": 624,
	"./loading-wheel-gif.gif": 624,
	"./location": 625,
	"./location-icon": 626,
	"./location-icon.png": 626,
	"./location.png": 625,
	"./logo-background2": 627,
	"./logo-background2.png": 627,
	"./logo1": 628,
	"./logo1.png": 628,
	"./logo2": 629,
	"./logo2.png": 629,
	"./low-battery": 630,
	"./low-battery.png": 630,
	"./loyalty_stamp": 631,
	"./loyalty_stamp.png": 631,
	"./manager-icon": 632,
	"./manager-icon.png": 632,
	"./menu-icon": 633,
	"./menu-icon.png": 633,
	"./menu-item-cover": 634,
	"./menu-item-cover.png": 634,
	"./mobile-icon2": 635,
	"./mobile-icon2.png": 635,
	"./mobile-newsletter": 636,
	"./mobile-newsletter.png": 636,
	"./new_cup": 637,
	"./new_cup.png": 637,
	"./next-arrow": 638,
	"./next-arrow.png": 638,
	"./number-one-icon": 639,
	"./number-one-icon.png": 639,
	"./online": 640,
	"./online.png": 640,
	"./orange-icon-location": 641,
	"./orange-icon-location.png": 641,
	"./orange-sound": 642,
	"./orange-sound.png": 642,
	"./pending_acceptance_icon.webp": 510,
	"./phone-call": 643,
	"./phone-call.png": 643,
	"./phone-whatapp-image": 644,
	"./phone-whatapp-image.png": 644,
	"./phone_screen": 645,
	"./phone_screen.png": 645,
	"./pinLeft": 646,
	"./pinLeft.png": 646,
	"./pindown": 647,
	"./pindown.png": 647,
	"./pinrigh": 648,
	"./pinrigh.png": 648,
	"./prev-arrow": 649,
	"./prev-arrow.png": 649,
	"./qr_code_icon": 650,
	"./qr_code_icon.svg": 650,
	"./receive": 651,
	"./receive.png": 651,
	"./rename-iphone-frame": 652,
	"./rename-iphone-frame.png": 652,
	"./reorder": 653,
	"./reorder.png": 653,
	"./scan-screen": 654,
	"./scan-screen.png": 654,
	"./share-icon": 655,
	"./share-icon.png": 655,
	"./shop-dashboard-background-mobile": 656,
	"./shop-dashboard-background-mobile.png": 656,
	"./shop-dashboard-billing-icon": 657,
	"./shop-dashboard-billing-icon.png": 657,
	"./shop-dashboard-device-status-icon": 658,
	"./shop-dashboard-device-status-icon.png": 658,
	"./shop-dashboard-home": 659,
	"./shop-dashboard-home.png": 659,
	"./shop-dashboard-manager-icon": 660,
	"./shop-dashboard-manager-icon.png": 660,
	"./shop-dashboard-menu-icon": 661,
	"./shop-dashboard-menu-icon.png": 661,
	"./shop-dashboard-mobile-icon2": 662,
	"./shop-dashboard-mobile-icon2.png": 662,
	"./shop-dashboard-staff-online-training": 663,
	"./shop-dashboard-staff-online-training.png": 663,
	"./shop-register-bg": 664,
	"./shop-register-bg-old": 665,
	"./shop-register-bg-old.jpg": 665,
	"./shop-register-bg.jpeg": 664,
	"./shop-register-bg_old": 666,
	"./shop-register-bg_old.jpg": 666,
	"./shop_dashborad_image": 667,
	"./shop_dashborad_image.png": 667,
	"./sound": 668,
	"./sound.png": 668,
	"./speechBubble": 669,
	"./speechBubble.png": 669,
	"./square-gift": 670,
	"./square-gift.png": 670,
	"./staff-online-training": 671,
	"./staff-online-training.png": 671,
	"./stroke-1@3x": 672,
	"./stroke-1@3x.png": 672,
	"./support": 673,
	"./support.png": 673,
	"./timer": 674,
	"./timer.png": 674,
	"./twitter2": 675,
	"./twitter2.png": 675,
	"./unionpay": 676,
	"./unionpay.jpg": 676,
	"./up-arrow": 677,
	"./up-arrow.png": 677,
	"./up_arrow": 678,
	"./up_arrow.gif": 678,
	"./upload": 679,
	"./upload-cover": 494,
	"./upload-cover.jpg": 914,
	"./upload-cover.png": 494,
	"./upload-image": 495,
	"./upload-image.jpg": 915,
	"./upload-image.png": 495,
	"./upload.png": 679,
	"./wallet-icon": 680,
	"./wallet-icon.png": 680,
	"./wastage": 681,
	"./wastage.png": 681,
	"./working-hours-icon": 682,
	"./working-hours-icon.png": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 911;